var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-decos"},_vm._l((new Array(_vm.c)),function(_,i){return _c('img',{key:i,staticClass:"mc-deco",style:(("top: " + (_vm.o + i * _vm.s) + "px; animation: " + (_vm.getAnimation(
        i,
        _vm.name[(_vm.r + i) % _vm.name.length]
      )) + " " + (50 + Math.floor(Math.random() * 30)) + "s linear 0s infinite;")),attrs:{"src":require(("@/assets/decoration/" + (_vm.name[(_vm.r + i) % _vm.name.length]) + ".png"))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }